import { Heading, Paragraph } from '@audio-network/componentlibrary'
import { usePlayer } from '@audio-network/player'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

import useFavouritesStore from '@/stores/favouritesStore'
import isDateOlderThan from '@/utils/formatting/isDateOlderThan'

import Spotlight from '../../../shared/Spotlight/Spotlight'
import { AddToFavouritesSpotlightProps } from './AddToFavouritesSpotlight.types'

const SPOTLIGHT_NAME = 'add-to-favourites'

export default function AddToFavouritesSpotlight({
	user,
}: AddToFavouritesSpotlightProps): JSX.Element {
	const { t } = useTranslation(['spotlights'])

	const { currentTrack } = usePlayer()
	const describesRef = useRef<string>('')
	const favouriteTracks = useFavouritesStore((state) => state.favouriteTracks)

	// Set the describes selector only once when currentTrack is first available
	if (currentTrack?.id && !describesRef.current) {
		describesRef.current = `[data-favourite="${currentTrack.id}"]`
	}

	const describes = describesRef.current

	if (!user || !describes) return null

	const isUserOlderThanOneWeek = isDateOlderThan(user.createdDate, 7)
	const hasFavourites = favouriteTracks.length > 0
	if (isUserOlderThanOneWeek || hasFavourites) return null

	return (
		<Spotlight describes={describes} name={SPOTLIGHT_NAME}>
			<Heading level={2} size="XS">
				{t('search-page.title')}
			</Heading>
			<Paragraph>{t('search-page.description')}</Paragraph>
		</Spotlight>
	)
}
